module.exports = {
  captchaConf: {
    appId: '2070586963',
    secretKey: '0QJBiRYIp7w7rPz444vZcVQ**',
  },
};